import { SpinnerCenter } from "@shapr3d/frontend-lib";

const LoadingPage: React.FC = () => {
  return <SpinnerCenter />;
};

export default LoadingPage;
